import { GameVars } from "./../../GameVars";
import { Button } from "./../../utils/Utils";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { BoardScene } from "./BoardScene";
import { AudioManager } from "../../AudioManager";

export class EndLayer extends Phaser.GameObjects.Container {

    private points2: Phaser.GameObjects.Text;
    private points3: Phaser.GameObjects.Text;

    private f: number;

    constructor(scene: Phaser.Scene, type: string) {

        super(scene);

        this.f = 0;

        let bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000, .75);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerdown", () => { 
            //
        });
        this.add(bck);

        bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000, .75);
        bck.fillRoundedRect(100, 160, GameConstants.GAME_WIDTH - 200, 440, 60);
        this.add(bck);

        bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000, .75);
        bck.fillRoundedRect(GameConstants.GAME_WIDTH / 2 - 400, 645, 800, 200, 40);
        this.add(bck);

        let title = new Phaser.GameObjects.Text(this.scene, 30, 10, type === GameConstants.END_WIN ? GameVars.gameText.GAME[8] : GameVars.gameText.GAME[9], {fontFamily: "HelveticaNeue", fontSize: "60px", color: "#FFFFFF"});
        this.add(title);

        let title2 = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, 220, "texture_atlas_language", type === GameConstants.END_WIN ? "win_txt" : "gameover_txt");
        this.add(title2);

        let endgameText = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, 420, "texture_atlas_language", "endgame_txt");
        endgameText.setOrigin(1, .5);
        this.add(endgameText);

        let points1 = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2 + 30, 265, GameVars.players[0].points.toString(), {fontFamily: "HelveticaNeue", fontSize: "90px", color: "#FFFFFF"});
        this.add(points1);

        this.points2 = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2 + 30, 370, GameVars.roundBonus.toString(), {fontFamily: "HelveticaNeue", fontSize: "90px", color: "#FFFFFF"});
        this.add(this.points2);

        this.points3 = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2 + 30, 475, GameVars.players[0].points.toString(), {fontFamily: "HelveticaNeue", fontSize: "90px", color: "#FFFFFF"});
        this.add(this.points3);

        let bottomText = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, 700, type === GameConstants.END_WIN ? GameVars.gameText.GAME[10] : GameVars.gameText.GAME[11], {fontFamily: "HelveticaNeue", fontSize: "40px", color: "#FFFFFF"});
        bottomText.setOrigin(.5);
        this.add(bottomText);

        let yesBtn = new Button(this.scene, GameConstants.GAME_WIDTH / 2 - 10, 780, "texture_atlas_language", type === GameConstants.END_WIN ? "btn_yes" : "btn_try", type === GameConstants.END_WIN ? "btn_yes_hover" : "btn_try_hover");
        yesBtn.setOrigin(1, .5);
        yesBtn.onDown(this.onYesDown, this);
        this.add(yesBtn);

        let noBtn = new Button(this.scene, GameConstants.GAME_WIDTH / 2 + 10, 780, "texture_atlas_language", type === GameConstants.END_WIN ? "btn_no" : "btn_quit", type === GameConstants.END_WIN ? "btn_no_hover" : "btn_quit_hover");
        noBtn.setOrigin(0, .5);
        noBtn.onDown(this.onNoDown, this);
        this.add(noBtn);

        this.scene.sys.updateList.add(this);

        AudioManager.playSound(type === GameConstants.END_WIN ? "game_success" : "game_over");
    }

    public preUpdate(time: number, delta: number): void {

        if (this.f < 60) {
            this.f++;
            return;
        }

        if (GameVars.roundBonus > 0) {
            GameVars.roundBonus -= 10;
            GameVars.players[0].points += 10;

            this.points2.setText(GameVars.roundBonus.toString());
            this.points3.setText(GameVars.players[0].points.toString());
        }
    }

    private onYesDown(): void {

        AudioManager.playSound("click");
        
        GameManager.enterBoardScene();
        BoardScene.currentInstance.removeEndScene();
    }

    private onNoDown(): void {

        AudioManager.playSound("click");
        
        GameManager.enterSplashScene(); 
        BoardScene.currentInstance.removeEndScene();
    }
}
